import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Paper, Tooltip } from "@material-ui/core";
import { CropDin, Timeline } from "@material-ui/icons";
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

const useStyles = makeStyles((theme)=> ({
    root: {
        position: 'absolute',
        left: 350,
        bottom: 20,
    }
}))

function MapToolBar(props){
    const classes = useStyles();
    const {mode} = props;

    return (
        <Paper className={classes.root}>
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <Tooltip title="Rectangle Mode" placement='right-end'>
                    <IconButton
                        color={mode === 'rectangle' ? 'primary': 'default'}
                        onClick={()=>{
                            props.markerSelectionModeChange('rectangle')
                        }}
                        disabled={props.enableCircle}
                    >
                        <CropDin />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Polygon Mode" placement='right-end'>
                    <IconButton
                        color={mode === 'polygon' ? 'primary': 'default'}
                        onClick={()=>{
                            props.markerSelectionModeChange('polygon')
                        }}
                    >
                        <Timeline />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Circle Mode" placement='right-end'>
                    <IconButton
                        color={mode === 'circle' ? 'primary': 'default'}
                        onClick={()=>{
                            props.markerSelectionModeChange('circle')
                        }}
                        disabled={!props.enableCircle}
                    >
                        <RadioButtonUncheckedIcon />
                    </IconButton>
                </Tooltip>
            </div>
        </Paper>
    )
}

export default MapToolBar